
  // Import the functions you need from the SDKs you need
  import { initializeApp } from "https://www.gstatic.com/firebasejs/12.7.0/firebase-app.js";
  import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.7.0/firebase-analytics.js";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyBKTRezWh4TEAdC17O8TWuju7dEBUrlZaw",
    authDomain: "veshh-eon.firebaseapp.com",
    projectId: "veshh-eon",
    storageBucket: "veshh-eon.firebasestorage.app",
    messagingSenderId: "981761118500",
    appId: "1:981761118500:web:de64222530bae7129ee3b1",
    measurementId: "G-BRR6DZSEBQ"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
